export interface ILocationItem {
  /** Идентификатор локации **/
  id: number;
  /** Название локации в именительном падеже (например, 'Московская область') **/
  name: string;
}

export enum EBuildersLocationsStatus {
  Initial = 'initial',
  Fetching = 'fetching',
  Success = 'success',
}

export interface IBuildersLocations {
  data: ILocationItem[];
  status: EBuildersLocationsStatus;
}
